<template>
  <div class="appointDiv-view">
    <div class="top-cont">
      <div class="left" v-if="rowDataObj.info">
        <div class="left-div">
          {{ rowDataObj.info.license_plate }}
        </div>
      </div>
      <div class="right">
        {{ rowDataObj.company_name }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">选择厂区：</div>
      <div class="right">
        {{ rowDataObj.company_name }}
      </div>
    </div>
    <div class="top-cont-text" v-if="rowDataObj.business.type != 0 && rowDataObj.business.type != 3">
      <div class="left">单据编号：</div>
      <div class="right" style="color: red;word-break: break-all;">
        {{ rowDataObj.order_code || '--' }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">收货单位：</div>
      <div class="right">
        {{ rowDataObj.delivery_unit || '--' }}
      </div>
    </div>
    <div class="top-cont-text" v-if="rowDataObj.business">
      <div class="left">选择业务：</div>
      <div class="right">
        {{ rowDataObj.business.name }}
      </div>
    </div>
    <div class="top-cont-text" v-if="rowDataObj.business">
      <div class="left">
        涉及{{ rowDataObj.business.type === 1 ? "产品线" : "业务子类" }}：
      </div>
      <div class="right">
        <div
          v-for="(item, index) in rowDataObj.business.sub_business"
          :key="index"
        >
          {{ item.name }}
          <span v-if="index !== rowDataObj.business.sub_business.length - 1"
            >、</span
          >
        </div>
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">车辆类型：</div>
      <div class="right" v-if="rowDataObj.info">
        {{
          rowDataObj.info.vehicle_type === 0
            ? "--"
            : vehicleColumns[rowDataObj.info.vehicle_type - 1]
        }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">预约时间：</div>
      <div class="right" v-if="rowDataObj.booking_time">
        {{ formatBookingTime(rowDataObj.booking_day) }}
        {{ rowDataObj.booking_time.begin_time }}-{{
          rowDataObj.booking_time.end_time
        }}
      </div>
    </div>
    <template v-if="rowDataObj.ref_order && rowDataObj.ref_order.id">
      <AppointOrderInfo :mode="0" :options="{
        type: rowDataObj.ref_order.type,
        id: rowDataObj.ref_order.id,
        name: rowDataObj.ref_order.code,
        rowDataObj
      }" v-model="rowDataObj.ref_order.id" />
    </template>
    <div class="top-cont-text">
      <div class="left">车牌号：</div>
      <div class="right" v-if="rowDataObj.info">
        {{ rowDataObj.info.license_plate }}
      </div>
    </div>
    <div class="top-cont-text" v-if="rowDataObj.info">
      <div class="left">司机姓名：</div>
      <div class="right">
        {{ rowDataObj.info.name || "--" }}
      </div>
    </div>
    <div class="top-cont-text" v-if="rowDataObj.info">
      <div class="left">司机身份证：</div>
      <div class="right">
        {{ rowDataObj.info.id_card || "--" }}
      </div>
    </div>
    <div class="top-cont-text" v-if="rowDataObj.info">
      <div class="left">司机手机号：</div>
      <div class="right">
        {{ rowDataObj.info.contact || "--" }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">备注：</div>
      <div class="right">
        {{ rowDataObj.note || "--" }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">当前预约状态：</div>
      <div
        class="right"
        :style="`color: ${stateColor[Number(rowDataObj.state)]}`"
      >
        {{ stateOption[Number(rowDataObj.state)] || "--" }}
      </div>
    </div>
    <div v-if="rowOverTime" class="top-cont-text">
      <div class="left">超时说明</div>
      <div class="right" :style="`color: ${stateColor[7]}`">
        {{ rowOverTimeText }}
      </div>
    </div>

    <div class="mid-cont">
      <div style="margin-bottom: 14px;">司机身份证正反面照片：</div>
      <div style="display: flex;">
        <div style="flex: 1;justify-content: center;align-items: center;">
          <img
            class="card-img"
            :src="previewFileList[0]"
            @click="preview_img(previewFileList, 0)"
          />
        </div>
        <span style="width: 10px;display: inline-block;"></span>
        <div style="flex: 1;">
          <img
            class="card-img"
            :src="previewFileList[1]"
            @click="preview_img(previewFileList, 1)"
          />
        </div>
      </div>
    </div>

    <div class="mid-cont">
      <div style="margin-bottom: 14px;">驾驶证主页和副页照片：</div>
      <div style="display: flex;">
        <div style="flex: 1;justify-content: center;align-items: center;">
          <img
            class="card-img"
            :src="previewFileList[2]"
            @click="preview_img(previewFileList, 2)"
          />
        </div>
        <span style="width: 10px;display: inline-block;"></span>
        <div style="flex: 1;">
          <img
            class="card-img"
            :src="previewFileList[3]"
            @click="preview_img(previewFileList, 3)"
          />
        </div>
      </div>
    </div>

    <div class="mid-cont">
      <div style="margin-bottom: 14px;">行驶证主页和副页照片：</div>
      <div style="display: flex;">
        <div style="flex: 1;justify-content: center;align-items: center;">
          <img
            class="card-img"
            :src="previewFileList[4]"
            @click="preview_img(previewFileList, 4)"
          />
        </div>
        <span style="width: 10px;display: inline-block;"></span>
        <div style="flex: 1;">
          <img
            class="card-img"
            :src="previewFileList[5]"
            @click="preview_img(previewFileList, 5)"
          />
        </div>
      </div>
    </div>

    <div class="mid-cont" v-if="rowDataObj.booking_attach && rowDataObj.booking_attach.length > 0">
      <div style="margin-bottom: 14px;">附件：</div>
      <div style="display: flex;gap: 10px;flex-wrap: wrap;">
        <div style="width: calc(50% - 5px);justify-content: center;align-items: center;" v-for="item in rowDataObj.booking_attach" :key="item.id">
          <img
            class="card-img"
            :src="item.real_path"
            @click="preview_img([item.real_path], 0)"
          />
        </div>
      </div>
    </div>
    <!--判断是否只读 -->
    <template v-if="!readonly">
      <!-- 预约状态：1未报到 2已报到 3报到失效 5已挂起 显示编辑和删除  其余情况隐藏 -->
      <div>
        <div v-if="rowDataObj.business.type != 0 && rowDataObj.business.type != 3" style="height: 182px;background-color: #f4f5f6;"></div>
        <div v-else style="height: 128px;background-color: #f4f5f6;"></div>
        <div class="footer-cont2">
          <template v-if="!(rowDataObj.state == 6 || rowDataObj.state == 7 || rowDataObj.state == 8)">
            <van-button v-if="rowDataObj.business.type == 1 && rowDataObj.ref_order_type !== 'tms'" style="margin-bottom: 10px;" block class="btnStyle1" type="primary" @click="editOrderCode">修改单据编号</van-button>
          </template>
          <template 
            v-if="
              (Number(rowDataObj.state) === 1 ||
                Number(rowDataObj.state) === 2 ||
                Number(rowDataObj.state) === 3 ||
                Number(rowDataObj.state) === 5) &&
                ((privilegeConfig.keys &&
                  privilegeConfig.keys.indexOf('c-car-apply-mine-mgr') >= 0) ||
                  dirverOrCoopUnit)
            "
          >
            <span v-if="rowDataObj.state === 2"></span>
            <van-button
              v-else
              type="primary"
              block
              class="btnStyle1"
              @click="onEdit"
              >编辑</van-button
            >
            <van-button block class="btnStyle2" @click="deleteAppoint"
              >删除</van-button
            >
          </template>
        </div>
      </div>
    </template>

    <!--加入排队 -->
    <div
      class=""
      v-if="
        ((privilegeConfig.keys &&
          privilegeConfig.keys.indexOf('c-car-apply-mine-mgr') >= 0) ||
          dirverOrCoopUnit) &&
          showReJoinline
      "
    >
      <div style="height: 182px;background-color: #f4f5f6;"></div>
      <!-- <div class="footer-cont2">
        <van-button type="primary" block class="btnStyle1" @click="reJoinline()"
          >加入排队</van-button
        >
      </div> -->
    </div>

    <!--盖篷布超时, 滞留超时 -->
    <div
      class=""
      v-if="
        ((privilegeConfig.keys &&
          privilegeConfig.keys.indexOf('c-car-apply-mine-mgr') >= 0) ||
          dirverOrCoopUnit) &&
          (showtarpaulinTimeOut || showretentionTimeOut)
      "
    >
      <div style="height: 128px;background-color: #f4f5f6;"></div>
      <div class="footer-cont2">
        <van-button
          v-if="showtarpaulinTimeOut"
          type="primary"
          block
          class="btnStyle1 mb20"
          @click="tarpaulinTimeOut"
          >盖篷布超时</van-button
        >
        <van-button
          v-if="showretentionTimeOut"
          type="primary"
          block
          class="btnStyle1"
          @click="retentionTimeOut"
          >滞留超时</van-button
        >
      </div>
    </div>

    <van-dialog
      v-model="deleteShow"
      title="警告"
      show-cancel-button
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <template #default>
        <div class="dialog-blk">
          您正在删除“<span class="colorGreenLight">
            {{ rowDataObj.info.license_plate }} </span
          >”关于“<span class="colorGreenLight">
            {{ formatBookingTime(rowDataObj.booking_day) }}
            {{ rowDataObj.booking_time.begin_time }}-{{
              rowDataObj.booking_time.end_time
            }}</span
          >”的预约记录！<br />
          <span style="color: #FE3141;">删除后不可恢复！</span>
        </div>
        <div style="display: flex;">
          <div style="flex: 1;" @click="confirmDelete">
            <van-button block class="dialogBtnConfirm">确认删除</van-button>
          </div>
          <div style="flex: 1;" @click="deleteShow = false">
            <van-button block class="dialogBtnCancel">取消</van-button>
          </div>
        </div>
      </template>
    </van-dialog>

    <!-- 盖篷布超时填写原因 -->
    <van-dialog
      v-model="tarpaulinDialogShow"
      class="vanDialog"
      show-cancel-button
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <template #default>
        <div class="pl16 pr16 vanDialogBody">
          <p class="actionQueueReasonTitle">
            "<span class="colorPink">{{ rowDataObj.info.license_plate }}</span
            >"超时{{
              showtarpaulinTimeOutCount
            }}分钟仍未确认篷布，请勾选超时原因：
          </p>
          <el-select
            v-model="showtarpaulinTimeOutreasonKey"
            popper-class="elSelectpopper"
            placeholder="请选择超时原因"
          >
            <el-option
              v-for="(item, index) in showtarpaulinTimeOutreason"
              :key="index"
              :label="item.name"
              :value="item.key"
            >
            </el-option>
          </el-select>
          <van-field
            v-model="showtarpaulinTimeOutreasonInput"
            rows="3"
            :border="true"
            autosize
            label=""
            type="textarea"
            maxlength="50"
            placeholder="请输入超时原因"
            show-word-limit
          />
        </div>
        <div class="pt20" style="display: flex">
          <div style="flex: 1" @click="tarpaulinDialogShow = false">
            <van-button block class="dialogBtnCancel">取消</van-button>
          </div>
          <div style="flex: 1" @click="onConfirmTarpaulin">
            <van-button block class="dialogBtnConfirm">确认无误</van-button>
          </div>
        </div>
      </template>
    </van-dialog>

    <!-- 滞留超时填写原因 -->
    <van-dialog
      v-model="retentionDialogShow"
      class="vanDialog"
      show-cancel-button
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <template #default>
        <div class="pl16 pr16 vanDialogBody">
          <p class="actionQueueReasonTitle">
            "<span class="colorPink">{{ rowDataObj.info.license_plate }}</span
            >"超时{{ showretentionTimeOutCount }}分钟仍未离厂，请勾选超时原因：
          </p>
          <el-select
            v-model="showretentionTimeOutreasonKey"
            popper-class="elSelectpopper"
            placeholder="请选择超时原因"
          >
            <el-option
              v-for="(item, index) in showretentionTimeOutreason"
              :key="index"
              :label="item.name"
              :value="item.key"
            >
            </el-option>
          </el-select>
          <van-field
            v-model="showretentionTimeOutreasonInput"
            rows="3"
            :border="true"
            autosize
            label=""
            type="textarea"
            maxlength="50"
            placeholder="请输入超时原因"
            show-word-limit
          />
        </div>
        <div class="pt20" style="display: flex">
          <div style="flex: 1" @click="retentionDialogShow = false">
            <van-button block class="dialogBtnCancel">取消</van-button>
          </div>
          <div style="flex: 1" @click="onConfirmRetention">
            <van-button block class="dialogBtnConfirm">确认无误</van-button>
          </div>
        </div>
      </template>
    </van-dialog>

    <!-- 修改单据编号及收货单位 -->
    <van-dialog v-model="editOrderCodeShow" title="修改单据编号" show-cancel-button @confirm="onEditOrderCodeConfirm">
      <div style="padding: 10px 20px;">
        <el-form :model="editOrderCodeFrom" label-width="5em" size="small">
          <el-form-item label="车牌号">{{ editOrderCodeFrom.license_plate || '--' }}</el-form-item>
          <el-form-item label="单据编号">
            <el-input v-model="editOrderCodeFrom.order_code" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="收货单位">
            <el-input v-model="editOrderCodeFrom.delivery_unit" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import moment from "moment";
import { ImagePreview } from "vant";
import privilegeMixin from "@/mixins/rh/privilegeMixin.js";
import AppointOrderInfo from './components/AppointOrderInfo.vue';
export default {
  data() {
    return {
      // 只读模式
      readonly: false,
      deleteShow: false,
      editOrderCodeShow: false,
      editOrderCodeFrom: {
        license_plate: '',
        order_code: '',
        delivery_unit: ''
      },
      rowDataObj: {},
      recentObj: {},
      vehicleColumns: ["平板车", "货柜车", "槽罐车", "其他", "高栏车"],
      previewFileList: [],
      stateOption: [
        "",
        "未报到",
        "已报到",
        "报到失效",
        "办理中",
        "已挂起",
        "已失效",
        "已关闭",
        "已完成",
        "已拒绝"
      ],
      stateColor: [
        "",
        "#B08931",
        "#00C8D2",
        "#666666",
        "#4F86F6",
        "#F5A623",
        "#666666",
        "#EC3F67",
        "#008B5E",
        "#EC3F67"
      ],
      retentionDialogShow: false,
      showretentionTimeOutreasonKey: "",
      showretentionTimeOutreasonInput: "",
      tarpaulinDialogShow: false,
      showtarpaulinTimeOutreasonKey: "",
      showtarpaulinTimeOutreasonInput: ""
    };
  },
  mounted() {
    this.getList();
    // localStorage.removeItem("appointModify");
  },
  mixins: [privilegeMixin],
  methods: {
    onEdit() {
      if (this.rowDataObj.business.type == 0 || this.rowDataObj.business.type == 3) {
        this.$router.push({
          path: '/rhwxAppointMaterialsModify/0?type=edit',
          query: {
            type: 'edit',
            pageType: 'detail',
            info_id: this.rowDataObj.info_id,
            id: this.rowDataObj.id,
            time1: this.time1,
            time2: this.time2,
            keyword: this.keyword
          }
        })
      } else {
        this.$router.push({
          path: '/rhwxAppointModify/0?type=edit',
          query: {
            type: 'edit',
            pageType: 'detail',
            info_id: this.rowDataObj.info_id,
            id: this.rowDataObj.id,
            time1: this.time1,
            time2: this.time2,
            keyword: this.keyword
          }
        })
      }
    },
    // 编辑单据编码确定
    onEditOrderCodeConfirm() {
      this.$common.http({
        url: '/api/queue/dispatcher/update_booking',
        data: {
          booking_id: this.rowDataObj.id,
          order_code: this.editOrderCodeFrom.order_code,
          delivery_unit: this.editOrderCodeFrom.delivery_unit
        }
      }).then(() => {
        this.getList();
      })
    },
    reJoinline() {
      this.$router.push({
        path: "rhwxReJoinline",
        query: {
          id: this.rowDataObj.id,
          info_id: this.rowDataObj.info_id
        }
      });
    },
    async onConfirmRetention() {
      if (this.showretentionTimeOutreasonKey.toString() == "") {
        this.$common.mbToastFail("请选择超时原因");
        return false;
      }

      let overtime_reason = "";
      let note = this.showretentionTimeOutreasonInput;
      let selctItem =
        this.showretentionTimeOutreason.find(item => {
          return item.key == this.showretentionTimeOutreasonKey;
        }) || {};
      overtime_reason = selctItem.name;

      if (
        this.showretentionTimeOutreasonKey == "other" &&
        note.trim().length == 0
      ) {
        this.$common.mbToastFail("请输入原因");
        return false;
      }

      await this.$common.http({
        url: "/api/queue/dispatcher/select_overtime_reason",
        data: {
          id: this.rowDataObj.id,
          type: 6,
          overtime_reason,
          note
        }
      });

      this.retentionDialogShow = false;

      this.getList();
    },
    retentionTimeOut() {
      this.retentionDialogShow = true;
    },
    async onConfirmTarpaulin() {
      if (this.showtarpaulinTimeOutreasonKey.toString() == "") {
        this.$common.mbToastFail("请选择超时原因");
        return false;
      }

      let overtime_reason = "";
      let note = this.showtarpaulinTimeOutreasonInput;
      let selctItem =
        this.showtarpaulinTimeOutreason.find(item => {
          return item.key == this.showtarpaulinTimeOutreasonKey;
        }) || {};
      overtime_reason = selctItem.name;

      if (
        this.showtarpaulinTimeOutreasonKey == "other" &&
        note.trim().length == 0
      ) {
        this.$common.mbToastFail("请输入原因");
        return false;
      }

      await this.$common.http({
        url: "/api/queue/dispatcher/select_overtime_reason",
        data: {
          id: this.rowDataObj.id,
          type: 5,
          overtime_reason,
          note
        }
      });

      this.tarpaulinDialogShow = false;

      this.getList();
    },
    tarpaulinTimeOut() {
      this.tarpaulinDialogShow = true;
    },
    preview_img(images, index) {
      ImagePreview({
        images: images, // 图片数组
        showIndex: true,
        loop: true,
        startPosition: index
        // closeable: true
      });
    },

    // 修改单据编号
    editOrderCode() {
      this.editOrderCodeFrom.license_plate = this.rowDataObj.info.license_plate;
      this.editOrderCodeFrom.order_code = this.rowDataObj.order_code;
      this.editOrderCodeFrom.delivery_unit = this.rowDataObj.delivery_unit;
      this.editOrderCodeShow = true;
    },

    // 删除预约信息
    deleteAppoint() {
      this.deleteShow = true;
      // setTimeout(() => {
      //   Toast.success("删除成功");
      // }, 2000);
    },

    getList() {
      this.$common
        .http({
          url: "/api/queue/dispatcher/get_booking_detail",
          data: {
            info_id: this.info_id
          }
        })
        .then(res => {
          console.log(res.data.data);

          this.previewFileList = [];
          this.rowDataObj = res.data.data;
          this.rowDataObj.file.forEach(item => {
            let index = "";
            if (Number(item.type) === 0) {
              index = 0;
            } else if (Number(item.type) === 1) {
              index = 1;
            } else if (Number(item.type) === 4) {
              index = 2;
            } else if (Number(item.type) === 5) {
              index = 3;
            } else if (Number(item.type) === 2) {
              index = 4;
            } else if (Number(item.type) === 3) {
              index = 5;
            }
            item.index = index;
            this.previewFileList.splice(item.index, 0, item.real_path);
            // this.previewFileList.push(item.real_path);
          });
        });
    },

    // 格式化预约时间
    formatBookingTime(str) {
      let str1 = String(str);
      if (moment().year() === Number(str1.substring(0, 4))) {
        return `${str1.substring(4, 6)}月${str1.substring(6, 8)}日`;
      } else {
        return `${str1.substring(0, 4)}年
          ${str1.substring(4, 6)}月
          ${str1.substring(6, 8)}日`;
      }
    },

    confirmDelete() {
      this.$common
        .http({
          url: "/api/queue/dispatcher/delete_booking",
          data: {
            id: this.id
          }
        })
        .then(res => {
          console.log(res.data.data);
          this.$common.mbToastSuccess("删除成功");
          setTimeout(() => {
            this.$router.push({
              path: "/rhwxAppointList",
              query: {
                time1: this.time1,
                time2: this.time2,
                keyword: this.keyword
              }
            });
          }, 1000);
        });
    }
  },
  created() {
    console.log(this.$route.query);
    if (this.$route.query.readonly) {
      this.readonly = this.$route.query.readonly == '1';
    }
  },
  computed: {
    showReJoinline() {
      return this.rowDataObj.satisfy_joining_finished_products;
    },
    rowOverTime() {
      if (
        this.rowDataObj.tarpaulin_overtime_state != 0 ||
        this.rowDataObj.retention_state != 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    rowOverTimeText() {
      let arr = [];
      if (this.rowDataObj.tarpaulin_overtime_state != 0) {
        arr.push("防护超时");
      }

      if (this.rowDataObj.retention_state != 0) {
        arr.push("滞留超时");
      }
      return arr.join(";");
    },
    showretentionTimeOutCount() {
      if (this.rowDataObj.retention_overtime_time) {
        return parseInt(this.rowDataObj.retention_overtime_time / 60) == 0
          ? 1
          : parseInt(this.rowDataObj.retention_overtime_time / 60);
      } else {
        return 0;
      }
    },
    showretentionTimeOutreason() {
      let arr = {
        list: [],
        other: false
      };
      try {
        arr = JSON.parse(this.rowDataObj.retention_reason);
      } catch (error) {
        console.log(error);
      }

      // return arr;
      // console.log(arr);
      // arr = {
      //   list: ["123123", "123123213111"],
      //   other: true
      // };

      let nList = [];
      arr.list.forEach((item, index) => {
        nList.push({ key: index, name: item });
      });
      if (arr.other) {
        nList.push({ key: "other", name: "其他" });
      }
      return nList;
    },
    showretentionTimeOut() {
      if (Number(this.rowDataObj.retention_state == 1)) {
        return true;
      } else {
        return false;
      }
    },

    showtarpaulinTimeOutCount() {
      if (this.rowDataObj.tarpaulin_overtime_time) {
        return parseInt(this.rowDataObj.tarpaulin_overtime_time / 60) == 0
          ? 1
          : parseInt(this.rowDataObj.tarpaulin_overtime_time / 60);
      } else {
        return 0;
      }
    },
    showtarpaulinTimeOutreason() {
      let arr = {
        list: [],
        other: false
      };
      try {
        arr = JSON.parse(this.rowDataObj.tarpaulin_overtime_reason);
      } catch (error) {
        console.log(error);
      }
      // test 模仿数据
      // console.log(arr);
      // arr = {
      //   list: ["123123", "123123213111"],
      //   other: true
      // };

      let nList = [];
      arr.list.forEach((item, index) => {
        nList.push({ key: index, name: item });
      });
      if (arr.other) {
        nList.push({ key: "other", name: "其他" });
      }
      return nList;
    },
    showtarpaulinTimeOut() {
      if (Number(this.rowDataObj.tarpaulin_overtime_state == 1)) {
        return true;
      } else {
        return false;
      }
    },
    info_id() {
      return this.$route.query.info_id;
    },
    id() {
      return this.$route.query.id;
    },
    time1() {
      return this.$route.query.time1;
    },
    time2() {
      return this.$route.query.time2;
    },
    keyword() {
      return this.$route.query.keyword;
    }
  },
  components: {
    AppointOrderInfo,
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.appointDiv-view {
  min-height: calc(100vh - 1px);
  background: #f4f5f6;
  font-size: 16px;
  .top-cont {
    display: flex;
    align-items: center;
    padding: 16px;
    background: #fff;
    .left {
      flex: 1.5;
      text-align: center;
      &-div {
        display: inline-block;
        background: #e5f3ee;
        padding: 5px 7px;
        color: #008b5e;
        margin-right: 14px;
        border-radius: 2px;
      }
    }
    .right {
      flex: 1;
      font-weight: bold;
    }
  }
  .top-cont-text {
    padding: 0px 16px 14px;
    background: #fff;
    display: flex;
    .left {
      // display: inline-block;
      // width: calc(36vw - 0px);
      flex: 1;
      text-align: right;
      margin-right: 40px;
      vertical-align: top;
      color: #b2b2b2;
    }
    .right {
      // display: inline-block;
      // width: calc(44vw - 0px);
      flex: 1.2;
      vertical-align: top;
      word-break: break-all;
    }
  }
  .mid-cont {
    background: #fff;
    margin-top: 10px;
    padding: 16px;
    font-size: 18px;
    color: #000000;
    line-height: 18px;
  }
  .card-img {
    object-fit: cover;
    // width: calc((100vw - 42px) / 2);
    width: 100%;
    height: calc((100vw - 42px) / 3.4);
    border-radius: 2px;
  }
  .dialog-blk {
    text-align: center;
    margin: 15px 17px 28px;
    font-size: 17px;
    color: #666666;
    line-height: 26px;
  }
  .pb20 {
    padding-bottom: 20px;
  }
  .mt20 {
    margin-top: 20px;
  }
  .mb20 {
    margin-bottom: 20px;
  }
}
</style>
<style lang="less">
.appointDiv-view {
  .van-dialog__header {
    opacity: 0.9;
    font-size: 17px;
    color: #000000;
    text-align: center;
  }
  .van-image__img {
    border-radius: 2px !important;
  }
}
.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus {
  border-color: rgb(192, 196, 204) !important;
}
.el-select {
  width: 100%;
}
.el-select-dropdown__item.selected {
  color: #008b5e !important;
}
.elSelectpopper {
  z-index: 5000 !important;
}
.el-select-dropdown {
  width: 285px;
}
.vanDialog .van-cell {
  margin-top: 5px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  textarea::-webkit-input-placeholder {
    color: rgb(192, 196, 204);
  }
}
.pt20 {
  padding-top: 20px;
}

.actionQueueReasonTitle {
  margin-bottom: 5px;
}

.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
</style>
